module.exports = {
	"_args": [
		[
			"esprima@https://registry.npmjs.org/esprima/-/esprima-2.7.2.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "esprima@>=2.5.0 <3.0.0",
	"_id": "esprima@2.7.2",
	"_inCache": true,
	"_location": "/esprima",
	"_phantomChildren": {},
	"_requested": {
		"name": "esprima",
		"raw": "esprima@https://registry.npmjs.org/esprima/-/esprima-2.7.2.tgz",
		"rawSpec": "https://registry.npmjs.org/esprima/-/esprima-2.7.2.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/esprima/-/esprima-2.7.2.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/",
		"/escodegen",
		"/eslint/js-yaml",
		"/js-yaml",
		"/recast",
		"/regexpu",
		"/svgo/js-yaml",
		"/webpack"
	],
	"_resolved": "https://registry.npmjs.org/esprima/-/esprima-2.7.2.tgz",
	"_shasum": "f43be543609984eae44c933ac63352a6af35f339",
	"_shrinkwrap": null,
	"_spec": "esprima@https://registry.npmjs.org/esprima/-/esprima-2.7.2.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"email": "ariya.hidayat@gmail.com",
		"name": "Ariya Hidayat"
	},
	"bin": {
		"esparse": "./bin/esparse.js",
		"esvalidate": "./bin/esvalidate.js"
	},
	"bugs": {
		"url": "https://github.com/jquery/esprima/issues"
	},
	"dependencies": {},
	"description": "ECMAScript parsing infrastructure for multipurpose analysis",
	"devDependencies": {
		"codecov.io": "~0.1.6",
		"escomplex-js": "1.2.0",
		"eslint": "~1.7.2",
		"everything.js": "~1.0.3",
		"glob": "^5.0.15",
		"istanbul": "~0.4.0",
		"jscs": "~2.3.5",
		"json-diff": "~0.3.1",
		"karma": "^0.13.11",
		"karma-chrome-launcher": "^0.2.1",
		"karma-detect-browsers": "^2.0.2",
		"karma-firefox-launcher": "^0.1.6",
		"karma-ie-launcher": "^0.2.0",
		"karma-mocha": "^0.2.0",
		"karma-safari-launcher": "^0.1.1",
		"karma-sauce-launcher": "^0.2.14",
		"lodash": "^3.10.0",
		"mocha": "^2.3.3",
		"node-tick-processor": "~0.0.2",
		"regenerate": "~1.2.1",
		"temp": "~0.8.3",
		"unicode-7.0.0": "~0.1.5"
	},
	"engines": {
		"node": ">=0.10.0"
	},
	"files": [
		"bin",
		"esprima.js",
		"unit-tests.js"
	],
	"homepage": "http://esprima.org",
	"keywords": [
		"ast",
		"ecmascript",
		"javascript",
		"parser",
		"syntax"
	],
	"license": "BSD-2-Clause",
	"main": "esprima.js",
	"maintainers": [
		{
			"name": "Ariya Hidayat",
			"email": "ariya.hidayat@gmail.com",
			"url": "http://ariya.ofilabs.com"
		}
	],
	"name": "esprima",
	"optionalDependencies": {},
	"readme": "[![NPM version](https://img.shields.io/npm/v/esprima.svg)](https://www.npmjs.com/package/esprima)\n[![npm download](https://img.shields.io/npm/dm/esprima.svg)](https://www.npmjs.com/package/esprima)\n[![Build Status](https://img.shields.io/travis/jquery/esprima/master.svg)](https://travis-ci.org/jquery/esprima)\n[![Coverage Status](https://img.shields.io/codecov/c/github/jquery/esprima/master.svg)](https://codecov.io/github/jquery/esprima)\n\n**Esprima** ([esprima.org](http://esprima.org), BSD license) is a high performance,\nstandard-compliant [ECMAScript](http://www.ecma-international.org/publications/standards/Ecma-262.htm)\nparser written in ECMAScript (also popularly known as\n[JavaScript](https://en.wikipedia.org/wiki/JavaScript)).\nEsprima is created and maintained by [Ariya Hidayat](https://twitter.com/ariyahidayat),\nwith the help of [many contributors](https://github.com/jquery/esprima/contributors).\n\n### Features\n\n- Full support for ECMAScript 6 ([ECMA-262](http://www.ecma-international.org/publications/standards/Ecma-262.htm))\n- Sensible [syntax tree format](https://github.com/estree/estree/blob/master/spec.md) as standardized by [ESTree project](https://github.com/estree/estree)\n- Optional tracking of syntax node location (index-based and line-column)\n- [Heavily tested](http://esprima.org/test/ci.html) (~1250 [unit tests](https://github.com/jquery/esprima/tree/master/test/fixtures) with [full code coverage](https://codecov.io/github/jquery/esprima))\n\nEsprima serves as a **building block** for some JavaScript\nlanguage tools, from [code instrumentation](http://esprima.org/demo/functiontrace.html)\nto [editor autocompletion](http://esprima.org/demo/autocomplete.html).\n\nEsprima runs on many popular web browsers, as well as other ECMAScript platforms such as\n[Rhino](http://www.mozilla.org/rhino), [Nashorn](http://openjdk.java.net/projects/nashorn/), and [Node.js](https://npmjs.org/package/esprima).\n\nFor more information, check the web site [esprima.org](http://esprima.org).\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/jquery/esprima.git"
	},
	"scripts": {
		"all-tests": "npm run generate-fixtures && npm run unit-tests && npm run grammar-tests && npm run regression-tests",
		"analyze-coverage": "istanbul cover test/unit-tests.js",
		"appveyor": "npm run all-tests && npm run browser-tests && npm run dynamic-analysis",
		"benchmark": "node test/benchmarks.js",
		"benchmark-quick": "node test/benchmarks.js quick",
		"browser-tests": "npm run generate-fixtures && cd test && karma start --single-run",
		"check-coverage": "istanbul check-coverage --statement 100 --branch 100 --function 100",
		"check-version": "node test/check-version.js",
		"circleci": "npm test && npm run codecov && npm run downstream",
		"codecov": "istanbul report cobertura && codecov < ./coverage/cobertura-coverage.xml",
		"complexity": "node test/check-complexity.js",
		"downstream": "node test/downstream.js",
		"droneio": "npm test && npm run saucelabs-evergreen && npm run saucelabs-ie && npm run saucelabs-safari",
		"dynamic-analysis": "npm run analyze-coverage && npm run check-coverage",
		"eslint": "node node_modules/eslint/bin/eslint.js -c .lintrc esprima.js",
		"generate-fixtures": "node tools/generate-fixtures.js",
		"generate-regex": "node tools/generate-identifier-regex.js",
		"grammar-tests": "node test/grammar-tests.js",
		"jscs": "jscs -p crockford esprima.js && jscs -p crockford test/*.js",
		"profile": "node --prof test/profile.js && mv isolate*.log v8.log && node-tick-processor",
		"regression-tests": "node test/regression-tests.js",
		"saucelabs-evergreen": "cd test && karma start saucelabs-evergreen.conf.js",
		"saucelabs-ie": "cd test && karma start saucelabs-ie.conf.js",
		"saucelabs-safari": "cd test && karma start saucelabs-safari.conf.js",
		"static-analysis": "npm run check-version && npm run jscs && npm run eslint && npm run complexity",
		"test": "npm run all-tests && npm run static-analysis && npm run dynamic-analysis",
		"travis": "npm test",
		"unit-tests": "node test/unit-tests.js"
	},
	"version": "2.7.2"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/esprima/package.json
 ** module id = ./node_modules/esprima/package.json
 ** module chunks = 0
 **/